import { InputBase as InputBaseMui } from '@mui/material'
import { InputBaseProps } from './Input.types'
import { KeyboardEvent, memo, useCallback } from 'react'
import { defaultAllowedKeys } from './Input.data'

function InputBase({ numeric, onKeyDown, ...props }: InputBaseProps) {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent<HTMLInputElement>) => {
      if (
        numeric &&
        !/[0-9]/.test(event.key) &&
        !event.ctrlKey &&
        !event.metaKey &&
        !event.altKey &&
        !defaultAllowedKeys.includes(event.key)
      )
        event.preventDefault()

      onKeyDown?.(event)
    },
    [numeric, onKeyDown],
  )

  return <InputBaseMui onKeyDown={handleKeyDown} {...props} />
}

export default memo(InputBase)
